import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, Injectable, NgModule } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RegistroService } from 'src/app/registro/registro.service';
import { ToastrService } from 'ngx-toastr';
import { ModalConfirmaLimparCamposComponent } from '../modal-confirma-limpar-campos/modal-confirma-limpar-campos.component';
import { ContadorService } from 'src/app/services/contador.service';
import { ErrorHandlerService } from 'src/app/errorHandler.service';
import { TokenService } from 'src/app/token.service';

@Component({
  selector: 'app-modal-cadastro-contador',
  templateUrl: './modal-cadastro-contador.component.html',
  styleUrls: ['./modal-cadastro-contador.component.scss']
})
export class ModalCadastroContadorComponent implements OnInit {

  @Input() cnpjSucessora;
  @Output() reload = new EventEmitter<any>();



  public isLoadCRC: boolean = false;
  public tipoDocCRC: string = 'cpf';
  public cpfCnpjCRC: string;
  public dadosCrc: any = {};
  public contador: any = {};
  public tipoDoc: string = 'cpf';
  public isLoading: boolean = false;
  public numeroCRC: string;
  public errorNumeroCRC: any = false;
  public seqCRCFull: string;

  public estados = [
    { "codigo": 1, "nome": "Acre", "sigla": "AC" },
    { "codigo": 2, "nome": "Alagoas", "sigla": "AL" },
    { "codigo": 4, "nome": "Amazonas", "sigla": "AM" },
    { "codigo": 3, "nome": "Amapá", "sigla": "AP" },
    { "codigo": 5, "nome": "Bahia", "sigla": "BA" },
    { "codigo": 6, "nome": "Ceará", "sigla": "CE" },
    { "codigo": 7, "nome": "Distrito Federal", "sigla": "DF" },
    { "codigo": 8, "nome": "Espírito Santo", "sigla": "ES" },
    { "codigo": 9, "nome": "Goiás", "sigla": "GO" },
    { "codigo": 10, "nome": "Maranhão", "sigla": "MA" },
    { "codigo": 13, "nome": "Minas Gerais", "sigla": "MG" },
    { "codigo": 12, "nome": "Mato Grosso do Sul", "sigla": "MS" },
    { "codigo": 11, "nome": "Mato Grosso", "sigla": "MT" },
    { "codigo": 14, "nome": "Pará", "sigla": "PA" },
    { "codigo": 15, "nome": "Paraíba", "sigla": "PB" },
    { "codigo": 17, "nome": "Pernambuco", "sigla": "PE" },
    { "codigo": 18, "nome": "Piauí", "sigla": "PI" },
    { "codigo": 16, "nome": "Paraná", "sigla": "PR" },
    { "codigo": 19, "nome": "Rio de Janeiro", "sigla": "RJ" },
    { "codigo": 20, "nome": "Rio Grande do Norte", "sigla": "RN" },
    { "codigo": 22, "nome": "Rondônia", "sigla": "RO" },
    { "codigo": 23, "nome": "Roraima", "sigla": "RR" },
    { "codigo": 21, "nome": "Rio Grande do Sul", "sigla": "RS" },
    { "codigo": 24, "nome": "Santa Catarina", "sigla": "SC" },
    { "codigo": 26, "nome": "Sergipe", "sigla": "SE" },
    { "codigo": 25, "nome": "São Paulo", "sigla": "SP" },
    { "codigo": 27, "nome": "Tocantins", "sigla": "TO" }
  ];

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private registroService: RegistroService,
    private toastyService: ToastrService,
    private contadorService: ContadorService,
    private errorHandler: ErrorHandlerService,
    private tokenService: TokenService
  ) { }

  @ViewChild('emailContabilista') emailContabilista: ElementRef<any>;
  @ViewChild('telefoneContabilista') telefoneContabilista: ElementRef<any>;

  public clear() {
    this.emailContabilista.nativeElement.value = '';
    this.telefoneContabilista.nativeElement.value = '';
  }

  ngOnInit() {
    this.tokenService.canActivate();
  }

  buscarContadorCRC() {
    this.tokenService.canActivate();
    this.errorNumeroCRC = false;
    this.isLoading = true;
    this.contadorService.getDadosDoCRC(this.cpfCnpjCRC)
      .then(data => {
        
        this.dadosCrc = data;        

        if(data.SitCad == 1) { 

          if(data.NumeroRegistro == this.numeroCRC.toUpperCase()) {          
            this.isLoadCRC = true;
            this.isLoading = false;
          }else {          
            this.isLoading = false;
            this.errorNumeroCRC = true;
          } 

          this.seqCRCFull = data.NumeroRegistro;

          this.contador.classificacaoCrc = data.NumeroRegistro.substring(0, 1);
          this.contador.codUf = data.NumeroRegistro.substring(1, 3);
          this.dadosCrc.NumeroRegistro = data.NumeroRegistro.substring(3, 10);          

        }

      })
      .catch(error => {
        this.errorHandler.handle(error);
        this.isLoading = false;
      })
  }

  loadBodyContador() {
    
    let body = {
      cnpjSucessora: this.cnpjSucessora,
      classificacaoCrc: this.contador.classificacaoCrc,
      ufCrc: this.contador.codUf,
      contato: {
        dddTelefone1: this.contador.telefone.substring(0, 2),
        telefone1: this.contador.telefone.substring(2, 11),
        correioEletronico: this.contador.correioEletronico
      },
      seqCrc: this.seqCRCFull,
      tipoCrc: this.dadosCrc.Tipo,
      nomeContabilista: this.dadosCrc.Nome,
      cpfCnpj: this.cpfCnpjCRC,
      //origemReceita : false
    }
    this.salvarCadastro(body);
  }

  salvarCadastro(body) {
    this.tokenService.canActivate();
    this.isLoading = true;
    this.contadorService.postContador(body)
      .then(data => {
        this.toastyService.success('Contador adicionado!');
        this.activeModal.dismiss();
        this.isLoading = false;
        this.reload.emit();
      })
      .catch(err => {
        this.errorHandler.handle(err);
        this.activeModal.dismiss();
        this.isLoading = false;
      })

  }

  openModalConfirmaLimparCampos() {
    
    const modalLimpeza = this.modalService.open(ModalConfirmaLimparCamposComponent, { size: 'lg', centered: true, backdrop: 'static', keyboard: false });
    modalLimpeza.componentInstance.clear.subscribe(() => {
      this.contador.correioEletronico = '';
      this.contador.telefone = '';
    })
  }



}
